<template>
  <div class="privacyGame">
      <!-- style="color: red;" -->     
 
 <p><b>梅州实渲个人隐私信息保护政策</b>

 </p><p>发布时间：2025年05月30日
 </p><p>生效时间：2025年05月30日
 </p><p>更新时间：2026年06月25日

 </p><p>欢迎您使用由梅州实渲网络科技有限责任公司（以下简称“本公司”或“我们”）开发并运营的网络游戏产品及相关服务。我们特此制定本《梅州实渲个人信息保护政策》（以下简称“本政策”），以便您了解我们如何收集、存储、使用、共享、转让、公开披露、删除您的个人信息，以及您所享有的相关权利等事宜。我们非常重视您的个人信息保护并充分尊重您的用户权利，请您仔细阅读本政策，并按照本政策的指引做出您认为适当的选择。 在使用我们的产品及服务前，请您务必仔细阅读本政策，特别是以粗体标识的条款，您应重点阅读，在充分理解本政策并同意后再开始使用我们的产品及服务。如您不同意本政策的任何内容，您应立即停止使用我们的产品及服务。

 </p><p>本政策为《梅州实渲用户协议》的组成部分，本政策中未约定的事宜，适用《梅州实渲用户协议》的约定。

 </p><p><b>摘要</b>

 </p><p>本摘要主要向您说明我们如何收集、处理您的个人信息 以及您享有的个人信息权利，如您想详细了解您的个人信息处理情况，以及我们处理您个人信息的而全部规则，请您阅读完整版《梅州实渲个人信息保护政策》。

 </p><p><b>一、我们如何收集和使用您的个人信息</b>

 </p><p>为提供基本功能服务，我们需要收集以下信息：
 </p><p>为提供注册、登录功能，我们将获取您的手机号码及短信验证码，或第三方账号公开信息（头像、昵称、身份验证信息以及您授权的相关信息）；在实名认证过程中，我们将获取您的 姓名、身份证号。
 </p><p>为保障账户安全及游戏正常启动运行，我们会收集移动设备的设备品牌、设备型号、设备版本、设备配置（包括存储内存）、设备平台、设备语言、手机运营商、手机制造商、手机CPU，设备MAC地址、设备硬件序列号、IMSI、IMEI、MEID、GAID（Android系统）、OAID（Android系统）、AndroidID（Android系统）、HarmonyOS(OAID、ODID）、UUID（iOS系统）、SIM卡序列号、IP地址、BSSID、SSID，应用安装列表、检索应用程序、进程信息，以及日志信息，包括登录日志、物品日志、交友记录以及游戏日志信息。
 </p><p>对于扩展业务功能所需信息，我们将根据您的授权进行收集和使用。

 </p><p><b>二、我们如何共享您的个人信息</b>
 </p><p>为保障我们的产品相关功能的实现及安全稳定运行，部分服务会由第三方提供，因此我们需要在您使用对应功能时向第三方共享您的个人信息 ，您可以通过<router-link to="/thirdPartyViewVue"> <b class="Policy">《与第三方共享个人信息清单》</b></router-link>查看我们与第三方共享个人信息的情况。

 </p><p><b>三、您如何管理您的个人信息</b>
 </p><p>您可以通过多种方式自行管理您的个人信息 ，包括查询、更新账号中的个人基本资料信息，改变您授权同意的范围，注销您的账户，如您无法通过上述方式管理您的个人信息或您在管理个人信息过程中遇到问题，您可以与我们联系。

 </p><p><b>四、未成年人信息保护</b>
 </p><p>我们高度重视未成年人的保护工作，如您是未成年人或其监护人，请仔细阅读本政策第 8 章中有关未成年人的规定，对于经监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息；如您是 14 周岁以下（含）的未成年人或其监护人，请访问<router-link to="/childrenPolicyViewVue"> <b class="Policy">《 梅州实渲儿童个人信息保护政策 》</b></router-link>。

 </p><p><b>五、如何联系我们</b>
 </p><p>若您对本政策或与您个人信息相关的事宜有任何问题、意见或建议，可以通过我们的电子邮箱（mzsxkefu@mzsxgames.com）与我们联系。

 </p><p><b>目录</b>

 </p><p>1、我们如何收集和使用您的个人信息<b style="color:red;">（包括收集目的，收集方式，收集范围）</b>
 </p><p>2、我们如何使用Cookie和同类技术
 </p><p>3、我们如何存储个人信息
 </p><p>4、我们如何保护您的个人信息
 </p><p>5、我们如何共享、转让、公开披露您的个人信息
 </p><p>6、您的权利
 </p><p>7、有关未成年人使用服务的提示
 </p><p>8、本政策的适用范围、变更以及例外情况
 </p><p>9、联系方式

 </p><p><b>1、 我们如何收集和使用您的个人信息（包括收集目的，收集方式，收集范围）</b>
 </p><p>根据《常见类型移动互联网应用程序必要个人信息范围规定》，本产品属于网络游戏类APP，基本业务功能为提供网络游戏产品和服务，必要个人信息为：注册用户移动电话号码；根据《关于防止未成年人沉迷网络游戏的通知》，为落实网络游戏用户账号实名注册制度，您还需要提供姓名、身份证号。

 </p><p>1.1 您须授权我们收集和使用您 个人信息 的情形
 </p><p>为了向您提供本公司产品及服务的核心功能，我们会收集、使用下列个人信息 ，如果您拒绝提供相关信息，您将无法享受本公司产品或服务的基本业务功能，这些功能包括：

 </p><p>1.1.1 注册登录
 </p><p>当您使用账号注册或登录功能时，您可能会在注册或登录时主动向我们提供您的个人基本资料，包括手机号码及短信验证码， 上述信息为必要个人信息 ，如您拒绝提供，您可能无法通过注册或登录从而使用我们的产品或服务 。
 </p><p>如您通过苹果应用商店、各大 安卓 应用商店下载或购买本公司产品或服务时，我们从该等应用商店处获取的您的信息，可能包括您的手机号码、账户信息， 上述信息为必要 个人信息 ，如您拒绝提供，您可能无法通过该等第三方下载或购买本公司产品或服务 。
 </p><p>如您授权以第三方账号，包括微博、微信、QQ 或各手机品牌用户账号登录使用我们的服务时，我们将获取您授权共享的该第三方账号下的相关信息，包括头像、昵称，以及身份验证信息，具体以您授权内容为准，并将您的第三方账号与我们的服务账号进行绑定，以便您可以通过第三方账号直接登录并使用我们的服务， 如您拒绝授权此类信息的，您将无法使用第三方账号登录并使用我们的服务 。

 </p><p>1.1.2 身份认证
 </p><p>为满足相关法律法规政策及相关主管部门的要求，您在开始或继续使用本公司游戏服务时需进行实名认证。我们会在获得您同意或您主动提供的情况下收集您的个人基本资料及个人身份信息，包括您的 姓名、身份证号，个人身份信息属于 个人敏感信息 ，且上述信息属于必要 个人信息 ，如您拒绝提供个人身份信息可能会导致您无法使用我们的游戏服务，或在使用游戏服务过程中受到相应的限制 。为实现实名认证的目的，您同意我们可以自行或委托第三方向有关机构提供、查询、核对您的前述身份信息。

 </p><p>1.1.3 <b style="color:red;">信息收集目的</b>
 </p><p>为了您能够在客户端查看您的历史记录，同时用于我们的运营统计分析、客户投诉处理及服务体验分析，我们会收集您的日志信息，包括登录日志、物品日志、交友记录、以及游戏日志信息。

 </p><p>1.1.4 <b style="color:red;">信息收集方式</b>
 </p><p>当玩家同意用户协议、隐私协议后，我们将按信息收集范围获得玩家信息；玩家有权拒绝我们收集用户信息；

 </p><p>1.1.5 <b style="color:red;">信息收集范围</b>
 </p><p>我们会收集移动设备的设备品牌、设备型号、设备版本、设备配置（包括存储内存）、设备平台、设备语言、手机运营商、手机制造商、手机CPU，设备MAC地址、设备硬件序列号、IMSI、IMEI、MEID、GAID（Android系统）、OAID（Android系统）、AndroidID（Android系统）、HarmonyOS(OAID、ODID）、UUID（iOS系统）、SIM卡序列号、IP地址、BSSID、SSID，应用安装列表、检索应用程序、进程信息。

 </p><p>1.2 您可选择是否授权我们收集和使用您个人信息的情形
 </p><p>如您使用了本公司产品及服务的其他业务功能，我们会收集、使用下列 个人信息 ，以为您提供本公司产品或服务的扩展业务功能：

 </p><p>1.2.1 信息发布与下载
 </p><p>如您使用我们产品或服务中的信息发布及相关交流互动功能，您可能会主动提供相关图文、视频、分享、互动行为信息。我们会收集记录您的上述信息，并展示您的昵称、头像、发布的信息内容，以便为您提供信息发布及相关交流互动功能并保存历史记录。 请您注意，您在公开区域上传或发布的信息可能会被他人收集并加以使用，且这些信息中可能包括 个人敏感信息 ，为保障您的人身和财产安全，请您谨慎提供。如您拒绝提供仅会使您无法使用该功能，但不会影响您使用基本业务功能。
 </p><p>在您访问产品特定功能页面时，我们会读取您的剪贴板内容以判断是否有相关口令码（包括邀请码、兑换码）信息，仅当剪贴板有前述口令码信息时，我们才会收集该口令码以向您提供您所需的内容，我们不会存储您的剪贴板其他信息，其中 兑换码属于个人敏感信息 ，请您谨慎提供。如您拒绝提供仅会使您无法使用该功能，但不会影响您使用基本业务功能。
 </p><p>为使您能够通过录屏、截屏的方式分享游戏内容，我们需要监听多媒体库，并获取悬浮窗权限，以悬浮显示录制按钮，还需要获取麦克风权限，以使用麦克风进行录音，获取录音内容。如您拒绝提供仅会使您无法使用该功能，但不会影响您使用基本业务功能。

 </p><p>1.2.2 消费与支付
 </p><p>当您使用消费功能时，我们会收集您的 充值记录、消费记录 ，以便您查询您的交易记录，同时尽最大程度保护您的财产安全，并在交易出现争议时为客服人员提供前述信息作为争议解决的依据。请您注意，充值记录、消费记录属于 个人敏感信息 ，请您谨慎提供。如您拒绝仅会使您无法使用该功能，但不会影响您使用其他功能。
 </p><p>为帮助您完成支付，我们需要临时存储游戏道具信息，我们会读取公共存储区以获取道具列表信息，用于支付前验证道具信息。
 </p><p>我们可能在我们的服务发生变化时向您发出与服务有关的公告。您可能无法取消和限制这些与服务有关且性质不属于推广的公告。

 </p><p>1.3 征得授权同意的例外。 根据相关法律法规及国家标准，我们可能会在以下情形中无需征求您的授权同意，收集、使用您的个人信息 ：
 </p><p>1.3.1 为订立或者履行您与我们之间的合同所必需的；
 </p><p>1.3.2 为本公司履行法定职责或法定义务所必需的；
 </p><p>1.3.3 为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需的；
 </p><p>1.3.4 为公共利益实施新闻报道、舆论监督等行为在合理的范围内处理 个人信息 ；
 </p><p>1.3.5 与国家安全、国防安全直接相关的；
 </p><p>1.3.6 与公共安全、公共卫生、公共网络安全、网络环境治理、重大公共利益直接相关的；
 </p><p>1.3.7 与刑事侦查、起诉、审判和判决执行等直接相关的；
 </p><p>1.3.8 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
 </p><p>1.3.9 所涉及的个人信息 是您自行向不特定社会公众公开的；
 </p><p>1.3.10 从合法公开披露的信息中收集 个人信息 的；
 </p><p>1.3.11 法律法规规定的其他情形。

 </p><p>1.4 为提供游戏服务功能，游戏可能需要接入以下第三方平台的SDK，第三方平台基于运营的需要将收集您的个人信息，第三方平台信息如下：</p>

  <div class="privacyGame">
    <p><b>1.4 为提供游戏服务功能，游戏可能需要接入以下第三方平台的 SDK，第三方平台基于运营的需要将收集您的个人信息，第三方平台信息如下：</b></p>

    <table border="1" cellspacing="0" cellpadding="8" style="width:100%; border-collapse:collapse; text-align:left; table-layout:fixed;">
      <thead>
        <tr>
          <th style="width:6%;">SDK 名称</th>
          <th style="width:6%;">公司名称</th>
          <th style="width:34%;">收集信息</th>
          <th style="width:20%;">使用目的和场景</th>
          <th style="width:34%;">SDK 联系方式</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Taku SDK</td>
          <td>广州塔酷信息科技有限公司</td>
          <td>
            <p><b>1. 必要信息</b></p>
            <p>(1) 设备信息</p>
            <p>【Android+iOS+HarmonyOS】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、限制广告追踪（LAT）状态、CPU信息、可用存储空间大小等基础信息</p>
            <p>【Android】Android ID、OAID</p>
            <p>【iOS】手机系统重启时间、磁盘总空间、系统总内存空间、IDFV</p>
            <p>【HarmonyOS】ODID</p>
            <p>(2) 网络信息</p>
            <p>【Android+iOS+HarmonyOS】运营商信息、Wi-Fi状态、网络信号强度</p>
            <p>【Android+iOS+HarmonyOS】IP地址</p>
            <p>(3) 应用信息</p>
            <p>【Android+HarmonyOS】Taku 合作方的应用包名、运行中的进程信息、版本号、应用前后台状态、SDK 版本号</p>
            <p>(4) 位置信息</p>
            <p>【Android，iOS和HarmonyOS】IP地址</p>
            <p>(5) 广告信息</p>
            <p>【Android+iOS+HarmonyOS】对广告的展示、点击及转化等交互数据</p>
            <p>(6) 性能数据</p>
            <p>【Android+iOS+HarmonyOS】如崩溃数据、性能数据</p>
            <p>获取MAC地址、SSID、IP、设备传感器信息</p>
          </td>
          <td>
            <p>1. 基于用户设备信息调整广告投放策略
            </p><p>2. 基于用户设备信息分析广告行为 (广告加载、展示、点击等)
            </p><p>3. 反作弊</p>
          </td>
          <td>
            Taku 隐私政策<br>
            <a href="https://help.takuad.com/docs/1Mn1B7" target="_blank">https://help.takuad.com/docs/1Mn1B7</a>
          </td>
        </tr>

        <tr>
          <td>TapSDK</td>
          <td>易玩（上海）网络科技有限公司</td>
          <td>
            <p>1. 系统版本</p>
            <p>2. 设备型号</p>
            <p>3. 设备 CPU 信息</p>
            <p>4. 网络类型</p>
            <p>5. Android ID</p>
            <p>6. 设备内存信息</p>
            <p>7. 设备指定应用信息</p>
            <p>8. 网络权限</p>
            <p>9. 获取网络状态</p>
            <p>10、获取 IP</p>
          </td>
          <td>
            <p>1. 服务故障时排查和优化
            </p><p>2. 当设备未安装时，引导用户完成 TapTap 客户端
            </p><p>3. 确保系统兼容性、定位问题
            </p><p>4. 获取已安装 TapTap 客户端信息
            </p><p>5. 访问网络数据
            </p><p>6. 检测网络连接是否有效</p>
          </td>
          <td>
            TapSDK 合规使用说<br>
            <a href="https://developer.taptap.cn/docs/sdk/start/agreement/" target="_blank">https://developer.taptap.cn/docs/sdk/start/agreement/</a>
          </td>
        </tr>


        <tr>
          <td>移动智能终端补充设备标识体系统一调用SDK</td>
          <td>移动安全工作委员会</td>
          <td>
            <p>设备制造商</p>
            <p>设备型号</p>
            <p>设备品牌</p>
            <p>设备网络运营商名称</p>
            <p>App包名及签名信息，或在对应应用商店的APPID</p>
            <p>允许访问设备标识符(OAID)</p>
            <p>获取OAID</p>
          </td>
          <td>
            <p>1、判断终端品牌，调用接口
            </p><p>2、判断是否为虚拟机环境
            </p>
          </td>
          <td>
            移动智能终端补充设备标识体系统一调用SDK 隐私协议: <br>
            <a href="https://www.msa-alliance.cn/col.jsp?id=122" target="_blank">https://www.msa-alliance.cn/col.jsp?id=122</a>
          </td>
        </tr>

        <tr>
          <td>穿山甲SDK</td>
          <td>北京巨量引擎网络技术有限公司</td>
          <td>
            <p>【Android+iOS+HarmonyOS】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、CPU信息、可用存储空间大小等基础信息</p>
            <p>【Android+HarmonyOS】OAID</p>
            <p>【Android】AndroidID</p>
            <p>【iOS】手机系统重启时间、磁盘总空间、系统总内存空间、IDFV</p>
            <p>【HarmonyOS】ODID</p>
            <p>获取Android ID、OAID、MAC地址、IP</p>
            <p>设备传感器信息</p>
          </td>
          <td>
            <p>广告投放及广告反作弊。
            </p><p>其中，IMEI、IDFA、AndroidID、OAID、设备的MAC地址、设备型号还会用于广告监测归因。
            </p>
          </td>
          <td>
            穿山甲广告SDK隐私政策<br>
            <a href="https://www.csjplatform.com/privacy/partner" target="_blank">https://www.csjplatform.com/privacy/partner</a>
          </td>
        </tr>

        <tr>
          <td>腾讯广告(优量汇)</td>
          <td>深圳市腾讯计算机系统有限公司</td>
          <td>
            <p>粗略位置信息</p>
            <p>设备/网络/系统信息</p>
            <p>[双端] 设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商[仅Android] 磁力、加速度、重力、陀螺仪传感器[仅ios] 设备名称、系统启动时间、系统语言、磁盘空间、设备姿态、压力传感器等基础信息</p>
            <p>标识符</p>
            <p>获取Android ID、设备传感器信息、IP、应用安装列表</p>
          </td>
          <td>
            <p>使用目的：广告投放、广告归因、广告反作弊、广告监测、最大程度减少App崩溃、确保服务器正常运行、提升可扩展性和性能
            </p>
          </td>
          <td>
            优量汇SDK个人信息保护规则<br>
            <a href="https://qzs.gdtimg.com/union/res/union_cdn/page/dev_rules/ylh_sdk_privacy_statement.html" target="_blank">https://qzs.gdtimg.com/union/res/union_cdn/page/dev_rules/ylh_sdk_privacy_statement.html</a><br>
            优量汇 SDK个人信息保护规则<br>
            <a href="https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983" target="_blank">https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983</a>           
          </td>
        </tr>

        <tr>
          <td>小米游戏联运SDK</td>
          <td>北京瓦力网络科技有限公司</td>
          <td>
            <p>允许访问oaid、设备手机型号名称(如:Redmi K40)、设备制造商</p>
            <p>允许访问网络可用状态</p>
            <p>允许访问应用包名、版本号</p>
            <p>允许访问传感器</p>
            <p>允许访问设备信息、网络信息</p>
          </td>
          <td>
            <p>使用小米游戏联运SDK为用户提供登录游戏、支付订单及游戏内交流功能</p>
          </td>
          <td>
            小米游戏联运SDK<br>
            <a href="https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1402" target="_blank">https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1402</a>
          </td>
        </tr>

        <tr>
          <td>米盟聚合广告SDK</td>
          <td>深圳小米信息技术有限公司</td>
          <td>
            <p>设备标识符：OAID；</p>
            <p>设备基础信息：设备型号、操作系统、屏幕宽高、屏幕密度、设备地区、存储信息、CPU信息；</p>
            <p>操作系统信息：Android版本号、系统版本名称、系统版本号、系统语言、SDK版本号；</p>
            <p>网络信息：IP地址、WiFi状态、运营商信息、网络类型、网络连接状态；</p>
            <p>应用信息：应用包名、版本号、应用前后台状态、运行中的进程信息；</p>
            <p>广告信息：对广告的展示、点击及转化等交互数据。</p>
            <p>小米操作系统版本号、SDK版本号、App版本号、系统版本号、操作系统、设备名、设备厂商、设备型号、UserAgent、IP、app包名、设备国家或地区、网络类型、时区、OAID、屏幕分辨率、屏幕密度</p>
          </td>
          <td>
            <p>1. 广告投放及广告监测归因、反作弊、广告投放统计</p>
            <p>2. 用于摇一摇等广告投放、反作弊</p>
            <p>3. 统计米盟聚合广告SDK的数据、减少SDK崩溃、提供稳定可靠的服务</p>
          </td>
          <td>米盟聚合广告SDK<br> 
            <a href="https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1756" target="_blank">https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1756</a>
          </td>
        </tr>


        <tr>
          <td>OPPO合作SDK</td>
          <td>广东欢太科技有限公司</td>
          <td>
            <p>手机号码、密码、注册短信内容、姓名、身份证号码、</p>
            <p>邮箱地址、地址、日志记录、应用进程列表信息、</p>
            <p>设备名称、设备型号、设备识别码（OAID）、手机型号、IP 地址、Wi-Fi ssid 、操作系统版本、</p>
            <p>会员等级、欢太帐号消费可币、游戏使用时间、游戏等级、关卡、游戏内消费记录</p>
          </td>
          <td>
            <p>1.向用户提供帐号注册、登录、实名认证、游戏浮标功能、售后及客户支持、网络连接、网络安全、产品优化、风险控制服务、积分、会员服务、游戏福利服务、游戏浮标功能、充值付费服务</p>
            <p>2. 向合作游戏提供分成结算服务。</p>
          </td>
          <td>
            SDK名称：合作游戏SDK开发者:广东欢太科技有限公司 <br> SDK隐私政策链接：<br> 
            <a href="https://ie-activity-cn.heytapimage.com/ie-activity/staticActivity/kpmYVr/htmls/kpmYVr.html?bizType=ie&actId=10001811&c=0;" target="_blank">https://ie-activity-cn.heytapimage.com/ie-activity/staticActivity/kpmYVr/htmls/kpmYVr.html?bizType=ie&actId=10001811&c=0;</a><br><br>

            SDK名称：移动智能终端补充设备标识体系统一调用SDK<br> 
            开发者:中国信息通信研究院 SDK隐私政策链接：<br> 
            <a href="https://www.msa-alliance.cn/col.jsp?id=122" target="_blank">https://www.msa-alliance.cn/col.jsp?id=122;</a>
          </td>
        </tr>

        <tr>
          <td>OPPO广告联盟</td>
          <td>深圳小米信息技术有限公司</td>
          <td>
            <p>收集您的可变设备标识（OAID、DUID、Android_ID），设备信息（机型、品牌），操作系统版本，屏幕分辨率，广告操作记录（用户点击、浏览时间）</p>
            <p>可选：</p>
            <p>收集您的粗略位置信息，精确位置信息，传感器信息（重力传感器、陀螺仪、加速度传感器、磁场传感器），软件列表信息，存储空间大小，WiFi信息（包括IP地址、bssid、ssid、连接的WiFi状态、WiFi列表），设备标识（IMSI、ICCID、Android ID、设备SN码）</p>
          </td>
          <td>
            <p>1. 收集您的粗略位置信息，精确位置信息，传感器信息（重力传感器、陀螺仪、加速度传感器、磁场传感器），软件列表信息，存储空间大小，WiFi信息（包括IP地址、bssid、ssid、连接的WiFi状态、WiFi列表），设备标识（IMSI、ICCID、Android ID、设备SN码）</p>
            <p>2. 提供个性化广告服务</p>
          </td>
          <td>
            SDK名称：OPPO联盟广告SDK<br> 开发者:广东欢太科技有限公司 SDK隐私政策链接：<br> 
            <a href="https://u.oppomobile.com/main/privacy.html" target="_blank">https://u.oppomobile.com/main/privacy.html;</a><br><br>

            SDK名称：优量汇 Android SDK<br> 开发者:深圳市腾讯计算机系统有限公司 SDK隐私政策链接：<br> 
            <a href="https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983" target="_blank">https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983;</a><br><br>

            SDK名称：快手联盟（Android）<br> 开发者:北京快手科技有限公司 SDK隐私政策链接：<br> 
            <a href="https://u.kuaishou.com/home/help/detail/1337/1425" target="_blank">https://u.kuaishou.com/home/help/detail/1337/1425;</a><br><br>

            SDK名称：鲸鸿动能SDK<br> 
            开发者:华为软件技术有限公司 SDK隐私政策链接：<br> 
            <a href="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582" target="_blank">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582;</a>
          </td>
        </tr>

        <tr>
          <td>vivo联运SDK</td>
          <td>广东天宸网络科技有限公司</td>
          <td>
            <p>设备信息（版本号、版本名称）、标识符(OAID、VAID、AAID)、</p>
            <p>账号信息（账号昵称、头像、openid、手机号码）</p>
            <p>网络信息（联网方式）</p>
            <p>手机制造商信息</p>
            <p>应用信息（开发者应用名、应用包名、版本号）</p>
          </td>
          <td>
            <p>使用vivo账号统一登录，支付，并提供统一的实名认证服务。</p>
          </td>
          <td>vivo联运SDK<br> 
            <a href="https://dev.vivo.com.cn/documentCenter/doc/712" target="_blank">https://dev.vivo.com.cn/documentCenter/doc/712</a>
          </td>
        </tr>

        <tr>
          <td>vivo广告联盟SDK</td>
          <td>广东天宸网络科技有限公司</td>
          <td>
            <p>设备信息：设备制造商，设备型号，系统版本，【可选】传感器信息（如加速度、重力、陀螺仪传感器）；</p>
            <p>网络信息：联网方式</p>
            <p>标识符信息：IMEI（仅限安卓9及以前版本），OAID，VAID</p>
            <p>应用信息：应用名称，应用包名，应用版本号</p>
            <p>应用使用信息：广告交互行为（广告互动记录，如曝光、点击、转化等信息）；</p>
            <p>诊断数据：崩溃数据、性能数据；</p>
          </td>
          <td>
            <p>1. 广告投放，反作弊，广告归因，广告监测，</p>
            <p>2. 减少App崩溃，提高稳定性和性能</p>
          </td>
          <td>vivo广告联盟SDK<br> 
            <a href="https://adnet.vivo.com.cn/home/agreement/18" target="_blank">https://adnet.vivo.com.cn/home/agreement/18</a>
          </td>
        </tr>

        <tr>
          <td>荣耀游戏联运SDK</td>
          <td>深圳荣耀软件技术有限公司</td>
          <td>
            <p>账号信息（Open ID、头像、昵称、UnionID）、设备信息（设备型号、设备操作系统版本、语言、ROM 版本、SIM卡的国家码信息、应用信息（应用包名、应用版本号、网络类型）、广告标识符（OAID）</p>
            <p>账号信息（Open ID、UnionID）、设备信息（设备型号、设备操作系统版本、语言、ROM 版本、SIM卡的国家码信息、运营商信息、应用信息（应用包名、应用版本号、网络类型）、应用使用信息、广告标识符（OAID）、设备标识符（udid、AndroidID）、网络信息（IP）、系统基本信息、活动参与信息（时间、类型）、优惠券信息</p>
            <p>网络权限/android.permission.INTERNET</p>
            <p>请求安装服务的权限/android.permission.REQUEST_INSTALL_PACKAGES</p>
          </td>
          <td>
            <p>1. 游戏启动/登录</p>
            <p>2. 实名认证</p>
            <p>3. 网络连接、网络安全、产品优化、风险控制</p>
            <p>4. 充值付费</p>
            <p>5. 使用联运服务时，提供网络连接联运游戏自升级服务</p>
            <p>6. 下载游戏升级apk文件，拉起系统安装器，安装游戏</p>
          </td>
          <td>荣耀游戏联运SDK<br> 
            <a href="https://developer.honor.com/cn/docs/game_center/guides/jieruzhinan/sdkyinsi" target="_blank">https://developer.honor.com/cn/docs/game_center/guides/jieruzhinan/sdkyinsi</a>
          </td>
        </tr>

        <tr>
          <td>荣耀广告SDK</td>
          <td>深圳荣耀软件技术有限公司</td>
          <td>
            <p>设备信息、网络信息、应用信息、应用使用信息、上下文信息、搜索词、广告主服务互动信息</p>
            <p>设备标识符、设备信息、网络信息、应用信息、应用使用信息、搜索词、广告主服务互动信息</p>
          </td>
          <td>
            <p>1. 广告展示、监测、归因及投放效果分析与优化</p>
            <p>2. 防欺诈及其它恶意行为</p>
          </td>
          <td>荣耀广告SDK<br> 
            <a href="https://developer.honor.com/cn/docs/20030/guides/sdk-privacy-statement" target="_blank">https://developer.honor.com/cn/docs/20030/guides/sdk-privacy-statement</a>
          </td>
        </tr>

        <tr>
          <td>好游快爆开发者SDK</td>
          <td>厦门纯游互动科技有限公司</td>
          <td>
            <p>软件安装读取、网络权限、设备型号、系统版本</p>
          </td>
          <td>
            <p>1. 用于判断是否安装快爆APP</p>
            <p>2. 用户检测网络状态</p>
            <p>3. 用于离线推送和SDK内部逻辑优化</p>
          </td>
          <td>好游快爆开发者SDK<br> 
            <a href="https://m.3839.com/html/hykb-265.html" target="_blank">https://m.3839.com/html/hykb-265.html</a>
          </td>
        </tr>

        <tr>
          <td>4399</td>
          <td>四三九九网络股份有限公司</td>
          <td>
            <p>设备型号、操作系统、Wifi状态</p>
            <p>获取进程信息（仅限于本应用）</p>
            <p>运营商信息、手机号，QQ账号、微信账号、微博账号、Ip地址</p>
            <p>设备录制视频、音频、修改音频设置、外部存储、传感器信息</p>
            <p>设备型号、设备系统版本、屏幕分辨率、网络状态</p>
            <p>允许访问以下权限：</p>
            <p>INTERNET</p>
            <p>ACCESS_WIFI_STATE</p>
            <p>ACCESS_NETWORK_STATE</p>
            <p>CHANGE_WIFI_STATE</p>
            <p>CHANGE_NETWORK_STATE</p>
            <p>REQUEST_INSTALL_PACKAGES</p>
            <p>READ_EXTERNAL_STORAGE</p>
            <p>RECORD_VIDEO</p>
            <p>MICROPHONE</p>
            <p>RECORD_AUDIO</p>
            <p>FOREGROUND_SERVICE</p>
            <p>CAMERA</p>
            <p>WAKE_LOCK</p>
            <p>涉及个人信息：设备标识符（IMEI、Android ID、OAID、IMSI、ICCID、GAID、MEID，设备序列号build_serial），设备制造商、设备品牌、型号、软件系统版本、屏幕方向、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息、CPU信息、可用存储空间大小、手机系统重启时间、手机系统更新时间、手机系统创建时间、磁盘总空间、系统总内存空间、运营商信息、设备MAC地址，IP地址，WLAN接入点（如SSID、BSSID），基站、附近的WIFI、连接的WIFI、Wi-Fi状态、网络类型、网络信号强度、软件列表、应用包名、运行中的进程信息、版本号、应用前后台状态、运行状态、宿主应用的可疑行为、设备传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器、重力传感器）、产品交互数据、广告数据（如展示、点击、转化广告数据）、精确位置信息、粗略位置信息，GPS位置信息、崩溃数据、性能数据</p>
          </td>
          <td>
            <p>1. 实现游戏安装</p>
            <p>2. 满足基础游戏服务功能</p>
            <p>3. 保证游戏正常运行</p>
            <p>4. 帮助用户登录、注销、账号切换，充值</p>
            <p>5. 广告推送</p>
            <p>6. 广告投放及监测归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</p>
          </td>
          <td>4399通行证用户服务协议<br> 
            <a href="https://ptlogin.4399.com/resource/protocol.html?type=1&aids=1,3,6,7" target="_blank">https://ptlogin.4399.com/resource/protocol.html?type=1&aids=1,3,6,7</a><br><br>
            4399隐私保护政策<br> 
            <a href="https://ptlogin.4399.com/resource/protocol.html?type=2&aids=4,10" target="_blank">https://ptlogin.4399.com/resource/protocol.html?type=2&aids=4,10</a><br><br>
            4399广告sdk隐私保护政策<br> 
            <a href="https://ptlogin.4399.com/resource/protocol.html?type=2&aids=8" target="_blank">https://ptlogin.4399.com/resource/protocol.html?type=2&aids=8</a><br><br>
            官网链接：
            <a href="https://union.4399.cn/" target="_blank">https://union.4399.cn/</a>
          </td>
        </tr>
        <tr>
          <td>Topon</td>
          <td>Topon Pte. Ltd.和Ascent Pro Technology Limited</td>
          <td>
            <p>设备信息（设备型号、系统版本、语言、网络状态等）</p>
            <p>广告标识符（GAID、IDFA、IDFV）</p>
            <p>IP 地址及大致位置信息</p>
            <p>应用信息（包名、版本号、SDK版本）</p>
            <p>广告交互数据（广告展示、点击、安装、转化事件）</p>
            <p>设备运行及诊断信息（崩溃日志、时间戳、网络状态等）</p>
          </td>
          <td>
            <p>用于提供广告投放和广告聚合服务、广告归因与效果分析、广告个性化推荐、广告反作弊、统计分析、产品优化以及保障服务安全稳定运行</p>
            
          </td>
          <td>Topon sdk 隐私协议 <br> 
            <a href="https://help.toponad.com/cn/docs/ByIf1V" target="_blank">https://help.toponad.com/cn/docs/ByIf1V</a>
          </td>
        </tr>
        <tr>
          <td>华为</td>
          <td>华为软件技术有限公司</td>
          <td>
            <p>华为帐号信息、应用信息（应用使用信息、应用基本信息）、设备信息（设备型号、设备硬件信息，系统属性、操作系统信息）、可变设备标识符 （可变的随机标识符）</p>
          </td>
          <td>
            <p>用于系统能力评估、分析服务质量。如果您只使用部分SDK功能，则可以根据实际功能进行裁剪。</p>         
          </td>
          <td>
            华为游戏服务 SDK
            <a href="https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/appgallerykit-game-sdk-security-0000001674895918#ZH-CN_TOPIC_0000001674895918" target="_blank">https://developer.huawei.com/consumer/cn/doc/AppGallery-connect-Guides/appgallerykit-game-sdk-security-0000001674895918#ZH-CN_TOPIC_0000001674895918;</a>
          </td>
        </tr>
        <tr>
          <td>鲸鸿动能 SDK</td>
          <td>华为软件技术有限公司</td>
          <td>
            <p>收集个人信息类型：设备标识符（包含OAID、ODID）、设备信息（设备型号、设备硬件信息、屏幕分辨率、存储空间大小、操作系统版本、系统设置、设备使用信息）、应用基本信息、应用设置信息、应用使用信息、传感器信息（陀螺仪、加速度计、旋转矢量传感器、磁力计、气压计）、网络信息、运营商信息、IP地址、WLAN信息（WiFi状态、WiFi参数、WiFi列表、BSSID与SSID）、位置信息（如精确位置信息（可选，不存储）与WLAN信息（WiFi列表、BSSID与SSID）、蓝牙列表）、广告互动信息</p>
          </td>
          <td>
            <p>程序化广告投放、广告监测归因、广告防欺诈与运营维护。</p>            
          </td>
          <td>
            鲸鸿动能SDK
            <a href="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582" target="_blank">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582;</a>
          </td>
        </tr>        

      </tbody>
    </table>
  </div>


 <p><b>2、 我们如何使用 Cookie 和同类技术</b>
 </p><p>为了统计和分析我们提供的网络产品及网络服务的运营效果，我们使用了若干自动数据收集工具，目前包括Cookie和Web beacon。借助这些技术，我们能够识别您的产品使用情况以及预防欺诈。我们承诺不会将上述技术用于本政策所述目的之外的任何用途。如您的设备或相关程序允许，您可以通过改变设置、或通过访问提供商的网页，来关闭或删除上述技术，但您这一举动可能会影响您的服务体验，部分服务也可能无法正常使用。

 </p><p><b>3、 我们如何存储个人信息</b>
 </p><p>我们会根据相关法律法规的要求，遵循 个人信息 保存时间最小化原则，合理地保存您的个人信息。

 </p><p>3.1 保存的方式和期限
 </p><p>我们会通过 AES 、 RSA 加密的方式存储您的信息，包括本地存储（例如利用 APP 进行数据缓存）、数据库和服务器日志等。
 </p><p>在您使用公司服务期间，我们会持续保存您的个人信息 。如您对账号进行注销或者公司产品停服，我们将从注销或停服之日起保存您的个人信息 3 年(本地存储除外)，如法律法规对相关个人信息规定了更长的存储期限，则我们会在法律法规规定的最短期限内保存您的个人信息。在超出上述期限后，我们会对您的相关信息进行删除或匿名化处理。

 </p><p>3.2 保存地域
 </p><p>我们在中华人民共和国境内收集和产生的个人信息 ，将存储在中华人民共和国境内。

 </p><p>3.3 您的个人信息如何在全球范围转移
 </p><p>我们不存在跨境传输您的个人信息的行为。

 </p><p><b>4 、 我们如何保护您的个人信息</b>
 </p><p>我们高度重视您的个人信息 的保护，采用了 AES 和 RSA 技术来确保您的个人信息的安全。

 </p><p>4.1 我们已使用符合业界标准的安全防务措施保护您提供的个人信息 ，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们使用了下列各种安全技术和程序，保护您的个人信息：
 </p><p>4.1.1 我们在您的浏览器或应用与服务器之间交换数据（如信用卡信息）时启用了 SSL 协议提供加密保护；
 </p><p>4.1.2 我们采取了传输层安全协议等加密技术，通过 HTTPS 等方式提供浏览服务，确保您的数据在传输过程中的安全；
 </p><p>4.1.3 我们确保第三方仅能通过 HTTPS 方式访问我们分享的API 接口，我们只提供账号验证功能，因此第三方是无法调取您的个人信息 ；同时我们采用了完善的防 SQL 注入手段，从而防止数据库系统受到外界攻击；
 </p><p>4.1.4 我们采取加密技术对您的个人信息 进行加密保存，您的密码是经过二次 MD5 等技术加密处理的，是密文信息；

 </p><p>4.2 我们只允许有必要知晓这些信息的公司及公司关联方的员工、合作伙伴访问您的个人信息 ，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。

 </p><p>4.3 互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码或不定期修改账号密码，并注意保护您的个人信息 安全。

 </p><p>4.4 我们将尽力确保您发送给我们的信息安全。如果我们的物理、技术、或管理防护设施遭到恶意破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。

 </p><p>4.5 如不幸发生 个人信息 安全事件，我们将按照法律法规的要求及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们会及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。

 </p><p><b>5 、 我们如何共享、转让、公开披露您的个人信息</b>

 </p><p>5.1 共享
 </p><p>为了实现业务功能，我们可能会向第三方共享您的个人信息 ，以实现您需要的服务或特定功能。如我们需要共享您的个人敏感信息 ，我们会再次征求您的授权同意。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享必要的个人信息。我们会通过签订协议的方式严格限制第三方使用您个人信息的行为，确保第三方按照我们的要求、本政策以及其他任何相关的保密和安全措施来处理个人信息。同时我们也会采取有效的技术保护措施保证您的个人信息在共享过程中的安全。我们会尽量对共享内容中的个人信息进行匿名化处理，您理解并同意，匿名化处理后的信息无法识别或关联到您，已不属于法律意义上的个人信息，其处理、使用、共享、转让无需征得您的授权同意。

 </p><p>目前，我们在以下情形中需要共享您的个人信息 ：
 </p><p>5.1.1 为便于我们基于本公司统一的账号体系向您提供一致化服务以及便于您进行统一管理，保障系统和账号安全，您的个人信息 可能会在本公司产品内部进行必要共享。
 </p><p>5.1.2 为保障我们的产品相关功能的实现及安全稳定运行，部分服务会由第三方提供，我们需要在您使用对应功能时向第三方共享您的个人信息 ，包括通过软件工具开发包（ SDK ）或其他类似的应用程序的方式。您在我们的产品中使用该等第三方提供的服务时，您同意由其直接收集和处理您的个人信息，我们会努力审查该第三方的业务准入资质并努力要求其合法合规性与安全性。为了最大程度保障您的信息安全，我们强烈建议您在使用由第三方服务商提供的服务前先行查看其 隐私 条款。为保障您的合法权益，如您发现第三方服务商提供的服务存在风险时，建议您立即终止相关操作并及时与我们取得联系。目前，我们的产品与第三方共享个人信息的情况请查阅 <router-link to="/thirdPartyViewVue"> <b class="Policy">《与第三方共享个人信息清单》</b></router-link> ， 产品内访问路径为设置 — 与第三方共享个人信息清单 。

 </p><p>5.2 转让
 </p><p>我们不会将您的个人信息转让给任何公司、组织或个人，但以下情况除外：

 </p><p>5.2.1 如遇特殊情况，在获得您的明确授权同意后，我们会向其他方转让您的个人信息 ；
 </p><p>5.2.2 在涉及合并、收购或破产清算时，如涉及到个人信息 转让，我们会要求新的持有您信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。

 </p><p>5.3 公开披露

 </p><p>我们仅会在以下情况下，公开披露您的个人信息：
 </p><p>5.3.1 在获得您的明确授权同意后；
 </p><p>5.3.2 基于有奖活动中的披露：如在公布中奖活动名单时，我们会脱敏展示中奖者手机号或登录名；
 </p><p>5.3.3 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息 ；
 </p><p>5.4 社交网络
 </p><p>我们的社交网络服务，是专为使您与世界各地的用户交流而设计，您可以使交流信息实时、广泛地传递。当您使用我们的服务中的社交网络功能时，您将可能分享一些个人信息 ，我们在某些服务中为您提供了可以自主控制个人信息分享的用户范围，同时您还可以要求我们删除您的相关个人信息。
 </p><p>5.4.1 您可能通过社交网络分享的个人信息 ：包括您在我们的服务中所上传或发布的信息（包括您公开的个人信息）、您对其他人上传或发布的信息作出的回应，您的战绩、排名，以及包括与这些信息有关的位置数据和日志信息；如您不同意在产品中公开前述个人信息，可以自行根据产品内指引关闭。
 </p><p>5.4.2 其他用户可能通过社交网络分享与您有关的信息；
 </p><p>5.4.3 关于共享信息删除：只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受公司控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存；
 </p><p>5.4.4 我们对您在社交网络分享信息的保护：在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围；你还可以要求从我们的服务中删除您的相关信息，请通过我们第 9 章所述的联系方式联系我们。

 </p><p>5.5 共享、转让、公开披露 个人信息 时事先征得授权同意的例外。 根据相关法律法规的规定，在以下情形中，我们共享、转让、公开披露个人信息不必事先征得您的授权同意：

 </p><p>5.5.1 与公司履行法律法规规定的义务相关的；
 </p><p>5.5.2 与国家安全、国防安全直接相关的；
 </p><p>5.5.3 与公共安全、公共卫生、重大公共利益直接相关的；
 </p><p>5.5.4 与刑事侦查、起诉、审判和判决执行等直接相关的；
 </p><p>5.5.5 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人授权同意的；
 </p><p>5.5.6 您自行向社会公众公开的个人信息 ；
 </p><p>5.5.7 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道 。

 </p><p><b>6 、 您的权利</b>
 </p><p>在您使用我们为您提供服务期间，我们可能会视服务具体情况为您提供相应的操作设置，以便您可以查询、更正、删除您的相关个人信息 ，注销您的用户账户，撤销已同意的授权，获取个人信息副本。按照相关的法律法规，我们保障您对自己的个人信息行使以下权利。此外，我们还设置了投诉举报 渠道 ，您可以通过第9章所述联系方式与我们取得联系，您的意见将会得到及时的处理。

 </p><p>6.1 您有权访问您的个人信息
 </p><p>您可以通过本政策第9条提供的联系方式与我们联系，我们将在15个工作日内给您回复。

 </p><p>6.2 您有权更正您的个人信息
 </p><p>您可以通过本政策第9条提供的联系方式与我们联系，我们将在15个工作日内给您回复。更正您的账号中的 个人基本资料信息。

 </p><p>6.3 您有权删除您的个人信息
 </p><p>在以下情形中，您可以向我们提出删除个人信息 的请求：

 </p><p>6.3.1 如果我们处理个人信息的行为违反法律法规；
 </p><p>6.3.2 如果我们收集、使用您的个人信息 ，却未征得您的同意；
 </p><p>6.3.3 如果我们处理个人信息的行为违反了与您的约定；
 </p><p>6.3.4 如果您不再使用我们的产品或服务，或您注销了账号；
 </p><p>6.3.5 如果我们不再为您提供产品或服务。
 </p><p>您可以通过本政策第9条提供的联系方式联系我们删除您的个人信息，若我们决定响应您的删除请求，我们会在15个工作日内删除，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。

 </p><p>6.4 您有权改变您授权同意的范围
 </p><p>我们向您提供的每个业务功能都需要一些您的基本个人信息才能得以完成，您可以在 <router-link to="/personalInformationViewVue"> <b class="Policy">《个人信息权限清单》</b></router-link> 中查看我们产品的个人信息权限申请与使用情况。如您想撤回您的授权同意，您可以在您使用的设备中进行修改，具体操作路径为：设置 — 应用 — 权限管理，或设置 — 隐私 ，或在我们的产品中通过隐私权限管理查阅个人信息的权限申请与使用情况并撤销权限使用的同意， 访问路径为设置 — 隐私权限管理 。
 </p><p>如您无法通过前述方式改变您授权同意的范围，您还可以通过本政策第9条提供的联系方式向我们提出申请，我们将在15个工作日内回复您的请求。
 </p><p>如您需要撤回收集必要个人信息的同意，或撤回收集全部个人信息的同意，将会导致我们无法为您提供本产品或服务的基本业务功能。在此情形下，如您仍希望撤回相关同意，您可以通过注销您的用户账户实现该需求，注销路径为：设置—用户中心—账号注销或设置—账号注销或账号—注销。
 </p><p>请您注意，在您收回同意的决定后，并不会影响此前基于您的授权而开展的个人信息处理。

 </p><p>6 .5 您有权注销您的用户账户
 </p><p>您随时可注销此前注册的账户，您可以在我们的产品或服务的相关功能设置页面向我们提交注销申请，我们将在15 天内注销您的账户。 注销路径为：设置—用户中心—账号注销或设置—账号注销或账号—注销。
 </p><p>如您无法通过前述方式注销账户，您也可通过本政策第9条提供的联系方式向我们提出申请。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，但法律法规另有规定的除外。

 </p><p>6.6 您有权申请获得个人信息副本
 </p><p>如您需要获取您的个人信息副本，您可以通过本政策第9条提供的联系方式向我们提出申请，我们将在15个工作日内回复您的申请。

 </p><p>6.7 个人信息 转移
 </p><p>如您需要将个人信息转移至指定的第三方的，您可以通过本政策第9条提供的联系方式向我们提出申请，我们将在15个工作日内回复您的申请。在技术可行且符合国家网信部门规定条件的情况下，我们可以按照您的要求，将您的个人信息转移至您指定的第三方。

 </p><p>6.8 信息系统自动决策的约束
 </p><p>如我们使用的信息系统依据自动决策机制作出决定，且这些决定对您的合法权益造成显著影响的，您有权通过本政策第9条提供的联系方式向我们反馈或投诉，我们将对自动决策结果进行人工复核或提供其他适当的救济方式。

 </p><p>6.9 响应您的请求
 </p><p>您可以通过本政策第9条提供的联系方式向我们提出与个人信息相关的请求，我们会在15个工作日内响应。为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
 </p><p>对于您的合理请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，请您理解我们将视情况收取一定成本费用。对于无端重复，需要过多技术手段，给他人合法权益带来风险或者不切实际的请求，很抱歉我们将可能会予以拒绝。

 </p><p>6.10 特殊情况
 </p><p>按照法律法规要求，很抱歉以下情形中我们将无法响应您的请求：

 </p><p>6.10.1 与本公司履行法律法规规定的义务相关的；
 </p><p>6.10.2 与国家安全、国防安全直接相关的；
 </p><p>6.10.3 与公共安全、公共卫生、重大公共利益直接相关的；
 </p><p>6.10.4 与刑事侦查、起诉、审判和判决执行等直接相关的；
 </p><p>6.10.5 有充分证据表明您存在主观恶意或滥用权利的；
 </p><p>6.10.6 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
 </p><p>6.10.7 响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
 </p><p>6.10.8 涉及商业秘密的。

 </p><p><b>7 、 有关未成年人使用服务的提示</b>
 </p><p>本公司非常重视对未成年人个人信息 的保护，18周岁以下的未成年人未经法定监护人同意不得使用我们的服务。如您是 18 周岁以下的未成年人的法定监护人，应监督和管控该未成年人使用我们服务的行为，该未成年人创建账户应通过您的事先同意。如您是14周岁以下（含）的未成年人的法定监护人，请访问<router-link to="/childrenPolicyViewVue"> <b class="Policy">《梅州实渲儿童个人信息保护政策》</b></router-link>。

 </p><p>7.1 对于经法定监护人同意而收集未成年人 个人信息 的情况，我们只会在受到法律允许、法定监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
 </p><p>7.2 如果未成年人未经法定监护人的同意而使用我们的服务，该未成年人的法定监护人有权与我们取得联系并要求我们删除该未成年人的个人信息 ，我们核实后将立即删除。
 </p><p>7.3 如果我们发现本公司在未事先获得可证实的法定监护人同意的情况下收集了未成年人的个人信息 ，则会设法尽快删除相关数据。

 </p><p><b>8 、 本政策的适用范围、变更以及例外情况</b>

 </p><p>8.1 适用范围
 </p><p>本政策适用于本公司提供的网络服务，当您使用我们为您提供的任何单项服务时，如该单项服务有特定的隐私 类政策，我们将在该单项服务对应的隐私类政策（ “ 特定政策 ” ）中更具体地说明我们在该等服务中如何使用您的个人信息 ，该特定政策构成本政策的一部分，并与本政策同时对您产生效力。如该特定政策与本政策存在同类条款不一致的约定，则在该特定政策约束范围内以特定政策为准。
 </p><p>我们的产品中可能包括指向第三方的链接，以帮助您访问第三方的服务或网站。 我们请您特别注意，该等第三方服务是由相关第三方运营商提供，为保障您的合法权益，请您仔细阅读相关第三方的 隐私 类政策指引。

 </p><p>8.2 本政策的变更
 </p><p>我们可能会根据公司业务或相关政策的调整对本政策进行修订，为了保障您的用户知悉权，我们将在本页面上发布对本政策所做的任何变更并通过应用内弹窗的方式提示您阅读，并重新征得您的授权同意。对于重大变更，我们还会在本页面首部进行明确提示，本政策所指的重大变更包括但不限于：

 </p><p>8.2.1 我们的服务模式发生重大变化时，如处理个人信息 的目的、处理的个人信息类型、个人信息的使用方式等；
 </p><p>8.2.2 我们在所有权结构、组织架构等方面发生重大变化时，如业务调整、破产并购等引起的所有者变更等；
 </p><p>8.2.3 个人信息 共享、转让或公开披露的主要对象发生变化时；
 </p><p>8.2.4 您参与个人信息 处理方面的权利及其行使方式发生重大变化时；
 </p><p>8.2.5 我们负责处理个人信息安全的责任部门、联络方式及投诉 渠道 发生变化时；
 </p><p>8.2.6 个人信息 安全影响评估报告表明存在高风险时。
 
 </p><p><b>9 、 联系方式</b>

 </p><p>如您对本政策有任何疑问、意见或建议，您可通过以下方式与我们联系。如您对我们的个人信息处理行为有任何投诉或申诉，您也可以通过以下方式与我们联系，我们会在15个工作日内回复处理意见或结果。

 </p><p>公司名称：梅州实渲网络科技有限责任公司
 </p><p>邮箱地址：mzsxkefu@mzsxgames.com
 </p><p>注册地址：梅州市梅江区三角镇富奇路富奇城2栋第8号
 </p><p>邮政编码：514021
 </p>

        <!-- <a href="">查看所有游戏></a> -->  
  </div>
</template>
<script>

export default {  
};
</script>
<style>
.privacyGame table, 
.privacyGame table th, 
.privacyGame table td {
  font-size: 18px;   /* 和 <p> 默认一样大 */
  font-weight: normal; /* 去掉表头的加粗效果，如果你不想加粗 */
  line-height: 1.6;  /* 让文字行距跟 <p> 类似 */
}
.privacyGame table th {
  font-size: 18px;   /* 跟 p 标签一致 */
  font-weight: bold; /* 加粗 */
  text-align: center; /* 居中 */
}
.privacyGame p {
  font-size: 18px;  /* 比默认16px小一号 */
  line-height: 1.6; /* 保持行距舒适 */
}
table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  th, td {
    border: 1px solid #000;
    padding: 8px;
    word-break: break-word;
    white-space: normal;
  }
</style>